import { Map as ImmutableMap } from 'immutable';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error not typed
import SequenceActions from 'sequences-crm-lib/flux/SequenceActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
// @ts-expect-error not typed
import SequenceUnenrollConfirmation from 'sequences-crm-lib/components/SequenceUnenrollConfirmation';
import { jsx as _jsx } from "react/jsx-runtime";
const CompactSequenceUnenrollModal = ({
  enrollment,
  objectType,
  subjectId,
  handleClose
}) => {
  const handleUnenroll = useCallback(() => SequenceActions.unenroll(enrollment.get('sequenceEnrollmentId') || enrollment.get('id'), subjectId, objectType).then(handleClose), [enrollment, subjectId, objectType, handleClose]);
  return /*#__PURE__*/_jsx(SequenceUnenrollConfirmation, {
    onConfirm: handleUnenroll,
    onReject: handleClose
  });
};
CompactSequenceUnenrollModal.propTypes = {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  enrollment: PropTypes.instanceOf(ImmutableMap).isRequired,
  objectType: ObjectTypesType.isRequired,
  handleClose: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired
};
export default CompactSequenceUnenrollModal;